import { callMBankBridge } from 'shared/lib/mbank-bridge'

export const previewPdfUrl = (url?: string) => {
  if (!url) return

  void callMBankBridge('pdf.previewUrl', { url }).then((response) => {
    if (response.ok) return

    window.open(url, '_blank')
  })
}
